import { useCallback, useEffect, useState } from 'react'
import { platformStoreGet } from '../../../../../shared/helpers.js'
import { checkPassportStatus } from '../../../actions/userActions'
import {
  isDonationActive,
  isDonationActiveOrPastDue,
} from '../../../actions/tvaultActions'
import { handleContentError } from '../utils'
import type { useDonationStatusProps } from '../types'

export default function useDonationStatus({
  callSign,
  enabled,
}: useDonationStatusProps) {
  const [isActiveDonation, setIsActiveDonation] = useState(false)
  const [isActiveOrPastDue, setIsActiveOrPastDue] = useState(false)
  const [unactivatedPassport, setUnactivatedPassport] = useState(false)
  const [error, setError] = useState(false)

  const fetchStatus = useCallback(async () => {
    try {
      const active = await isDonationActive()
      const pastDue = await isDonationActiveOrPastDue()
      setIsActiveDonation(active)
      setIsActiveOrPastDue(pastDue)
    } catch (err) {
      handleContentError('Getting donation status', err)
      setError(true)
    }
  }, [])

  const fetchUnactivatedPassport = useCallback(async () => {
    if (platformStoreGet('mvault_id')) {
      const status = await checkPassportStatus(callSign)
      if (status === 'PENDING') {
        setUnactivatedPassport(true)
      }
    }
  }, [callSign])

  useEffect(() => {
    if (enabled) {
      fetchStatus()
    }
  }, [enabled, fetchStatus])

  useEffect(() => {
    if (enabled && (isActiveOrPastDue || error)) {
      fetchUnactivatedPassport()
    }
  }, [enabled, isActiveOrPastDue, error, fetchUnactivatedPassport])

  return { isActiveDonation, isActiveOrPastDue, unactivatedPassport, error }
}
